import { Dispatch } from "react"
import { useSelector } from "react-redux"
import { getStageInspectionModules } from "../../../../../../../core/actions/configurator-actions"
import { IStore } from "../../../../../../../core/store"
import { DependencyPivot } from "../../../common/pivots/DependencyPivot"
import { ShowConfigurationPivot } from "../../../common/pivots/ShowConfigurationPivot"
import { SkipPivot } from "../../../common/pivots/SkipPivot"
import { TInspectionSettingsPivotStates } from "../../InspectionModule"
import { InspectionModeCommonSettingsPivot } from "../../settings/mode/InspectionModeCommonSettingsPivot"
import { DiagnosticsUISettingsPivot } from "./DiagnosticsUISettingsPivot"
import { ProcessStages } from "@piceasoft/core"
import { DiagnosticsPushSettingsPivot } from "./DiagnosticsPushSettingsPivot"

type TProps = {
    state: TInspectionSettingsPivotStates
    stage: ProcessStages
    index: number
    onChangeDispatch: Dispatch<any>
    onClose: () => void
    withoutGrade?: boolean
}

export const DiagnosticsSettingsPivotBasedState: React.FC<TProps> = (props) => {
    switch (props.state) {
        case "ui": return (
            <DiagnosticsUISettingsPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch} />
        )
        case "common": return (
            <InspectionModeCommonSettingsPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch} withoutGrade={props.withoutGrade} />
        )
        case "dependency_inspections": return (
            <DependencyPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch} />
        )
        case "skip": return (
            <SkipPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch} onClose={props.onClose} />
        )
        case "config": return (
            <ShowConfigurationPivot json={useSelector((s: IStore) => getStageInspectionModules(props.stage, s)?.find(i => i.index === props.index)) ?? {}} />
        )
        case "push": return (
            <DiagnosticsPushSettingsPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch} />
        )
        default:
            return (
                <></>
            )
    }
}
